import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Icon, SR_ICONS } from '@sr/ui-library';
import { ReactNode } from 'react';
import { useLoaderData, useParams } from 'react-router-dom';
import { AppLoader } from '../components/Loader';
import ProtectElement, {
  IProtectElementProps,
} from '../components/ProtectElement';
import { configuration } from '../configuration';
import { TProtectRouteLoaderData } from '../types/commonTypes';

export interface IProtectRouteProps {
  children?: ReactNode;
  isAuthenticated?: boolean;
  onAuthorised?: (workspaceId?: string) => void;
  permissionRequired?: IProtectElementProps['permissionRequired'];
}

const ProtectRoute = ({
  children,
  onAuthorised: handleAuthorised,
  permissionRequired = [],
}: IProtectRouteProps) => {
  const loaderData = useLoaderData() as TProtectRouteLoaderData;
  const { workspaceId } = useParams();

  const resolvedPermissions =
    loaderData?.permissionRequired === null
      ? null
      : [
          ...(permissionRequired ?? []),
          ...(loaderData?.permissionRequired ?? []),
        ];

  return (
    <ProtectElement
      permissionRequired={resolvedPermissions}
      showErrorPage
      workspaceId={workspaceId}
      onAuthorised={() => handleAuthorised?.(workspaceId)}
    >
      {children}
    </ProtectElement>
  );
};

const ProtectRouteRedirecting = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-8 p-10 text-center">
    <Icon className="mb-5 size-28 text-read-only-bg" icon={SR_ICONS.lock} />
    <p className="text-base">Please wait while we redirect you to login...</p>
    <AppLoader.FlexLoader />
  </div>
);

// When Cognito is active, the Authenticator component already gates access --
// unauthenticated users see the login form, not the app. No HOC needed.
export default configuration.COGNITO_ENABLED
  ? ProtectRoute
  : withAuthenticationRequired(ProtectRoute, {
      onRedirecting: ProtectRouteRedirecting,
    });
